import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LoginsActiveTable from './LoginsActiveTable';
import LoginInactive from './LoginInactive';
import loginPropTypes from '../../proptypes/login';
import { getLoginLogo } from '../../utils/loginPropMap';
import loginsIcon from '../../img/icons/logins.svg';
import style from '../../style/components/signin/Logins.module.scss';
import Card from '../Card';

const Logins = ({ handleAdd, handleDelete, logins, loginsInactive }) => {
  const { t } = useTranslation();

  return (
    <Card
      title={t('signin.logins.title')}
      icon={<img className={style.img} alt="logins" src={loginsIcon} />}
      className={style.logins}
    >
      <h4 className={style.subtitle}>{`Active (${logins.length})`}</h4>
      <LoginsActiveTable logins={logins} handleDelete={handleDelete} />
      {loginsInactive.length > 0 && (
        <>
          <h4 className={style.subtitle}>Inactive</h4>
          <p>{t('signin.logins.description_inactive')}</p>
          <section className={style.inactive}>
            {loginsInactive.map((login) => (
              <LoginInactive
                {...login}
                key={login.handle}
                className={style.inactiveItem}
                handleAdd={handleAdd}
                logo={getLoginLogo(login.handle)}
              />
            ))}
          </section>
        </>
      )}
    </Card>
  );
};

Logins.propTypes = {
  handleDelete: PropTypes.func.isRequired,
  logins: PropTypes.arrayOf(loginPropTypes),
  loginsInactive: PropTypes.arrayOf(loginPropTypes),
};

Logins.defaultProps = {
  logins: [],
  loginsInactive: [],
};

export default memo(Logins);
